type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const credits = {
  website: 'www.octoplusit.com',
  name: 'Octoplus IT',
  buyLink: '/',
}

export const basePath: string = '/'
